<app-form-input
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="typeCPVClass?.classPrincipale"

	[label]="step3.getclassprincipale"
	[type]="'autocompleteWithStar'" [rule]="'pattern_17'"
	[errorMessage]="{'pattern' : 'ctr_1113'}"
	[autoCompleteType]="'CPV'" [autoCompleteTypeIndex]="1"
	[name]="getUid()+'_SepAtt_classPrincipale'"
  [preferenceType] = "typeCpv"
  (preferenceSelected)="chargeDonneePreference($event)">
</app-form-input>
